import psl_ui from '../../libs/psl_ui.js';
import {wait} from '../../libs/psl_polyfills.js';

import audio from '../../components/audio.js';

import instructions from '../../components/instructions/component.js';
import steps_component from '../../components/steps/component.js';

import './style.scss';
import template from './template.pst';


psl_ui.templates.add('page_what_should_you_do',template);

const {el,rpoints}=psl_ui.templates.render('page_what_should_you_do');

rpoints.option_0.addEventListener('click',e=>{
	if(_state.status==='correct' || _state.status==='incorrect') return;
	_unblur(false);
	_select(0);
});
rpoints.option_1.addEventListener('click',e=>{
	if(_state.status==='correct' || _state.status==='incorrect') return;
	_unblur(false);
	_select(1);
});
rpoints.option_2.addEventListener('click',e=>{
	if(_state.status==='correct' || _state.status==='incorrect') return;
	_unblur(false);
	_select(2);
});

rpoints.finish.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

let _state={
	finished:0,
	step:0,
	status:'question',
	selected:undefined,
	answers:[],
	questions:[],
};

let _clb;

const _unblur = (v=true)=>{
	rpoints.choices.classList.remove('blur');
	for(let i=0;i<3;i++) rpoints[`option_${i}`].removeAttribute('tabindex');

	rpoints.result.removeAttribute('aria-hidden');
	rpoints.choices.removeAttribute('aria-hidden');
	rpoints.desc.removeAttribute('aria-hidden');

	if(v) rpoints.q_text.focus();
}

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/900;
		height=height/1800;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

const questions = [
	{
		i:0,
		q:'The driver of your car just received a ding from their phone. They have a new text message. Should they:',
		opts:[
			{t:'Check it right away. It might be important.'},
			{t:'Wait to check it at a red light.'},
			{t:'Ignore the message until they\'re no longer driving.',valid:true}
		]
	},

	{
		i:1,
		q:'You are enjoying your road trip snacks, and the driver looks hungry, too. Do you:',
		opts:[
			{t:'Hand them some Twizzlers because they\'re easy to eat while driving.'},
			{t:'Loudly smack your lips and talk about how awesome your snacks are.'},
			{t:'Share your snacks at the next rest stop.',valid:true}
		]
	},

	{
		i:2,
		q:'Your favorite song just came on the radio. This is your jam and you NEED to sing on the chorus. Do you:',
		opts:[
			{t:'Put the windows down and turn the music waaaay up. You need to feel it.'},
			{t:'Enjoy your song at the current volume. Sing along but at a respectable level.',valid:true},
			{t:'Cry because you just love this song so so much.'}
		]
	},

	{
		i:3,
		q:'You are watching YouTube in the backseat and just saw the most hilarious thing ever. You have to show someone. Should you:',
		opts:[
			{t:'Save it to show the driver later. Then keep watching.',valid:true},
			{t:'Immediately hit replay. Turn your screen and share it with the driver.'},
			{t:'Loudly describe every detail of the moment.'}
		]
	},

	{
		i:4,
		q:'Another passenger in the car is getting on your very last nerve with their talking. Do you:',
		opts:[
			{t:'Start arguing with them loudly because you just can\'t take it anymore.'},
			{t:'Ignore them. You don\'t want to be a distraction to the driver.',valid:true},
			{t:'Be really loud yourself to hopefully drown out their noise and talking.'}
		]
	},

	{
		i:5,
		q:'You see a road sign about slow traffic ahead, but you don\'t think the driver sees it. Do you:',
		opts:[
			{t:'Go back to your book, app, or movie. They\'ll see it eventually.'},
			{t:'Scream out at the driver to pay attention.'},
			{t:'Ask the driver if they saw the sign.',valid:true}
		]
	},

	{
		i:6,
		q:'You forgot to get your book out of your bag during the last stop and really want to read the next chapter. Do you:',
		opts:[
			{t:'Wait it out until the next stop.',valid:true},
			{t:'Quick unbuckle and reach into the back to get your book.'},
			{t:'Annoy the driver until they stop.'}
		]
	},

	{
		i:7,
		q:'You just saw someone you know pass you in the car just ahead. Do you:',
		opts:[
			{t:'Yell at the driver to speed up so you can say hello.'},
			{t:'Start banging on the window to get their attention.'},
			{t:'Do nothing. Sometimes you just see people you know.',valid:true}
		]
	},

	{
		i:8,
		q:'You notice the driver digging through their bag and not paying attention to the road. Do you:',
		opts:[
			{t:'Ask the driver if you can help so they can drive.',valid:true},
			{t:'Laugh at them because they can\'t find what they\'re looking for.'},
			{t:'Do nothing.'}
		]
	},

	{
		i:9,
		q:'It\'s dark out, and you\'re walking. You have the walk sign at a crosswalk, but you don\'t think the driver sees you. Do you:',
		opts:[
			{t:'Start to cross just a little bit to see if they notice you.'},
			{t:'Wait until you see the driver acknowledge you before you cross.',valid:true},
			{t:'Jump up and down to get their attention.'}
		]
	}
]

const _amount = 3;

const init = async (clb)=>{
	instructions.text='Choose the correct answer about distractions in the car to move on.';
	instructions.append(rpoints.container,_unblur);
	rpoints.choices.classList.add('blur');

	rpoints.choices.appendChild(steps_component.view);

	_state.questions = questions.map(q=>({...q,opts:[...q.opts].sort(()=>(0.5-Math.random()))})).sort(()=>(0.5-Math.random()));

	_state.questions.length=_amount;

	_state.step=0;
	_state.answers=[];
	_state.finished=0;
	_state.status='question';
	_state.selected=undefined;

	rpoints.result.classList.add('hidden');
	rpoints.finish.classList.add('hidden');
	rpoints.finish.setAttribute('tabindex','-1');
	rpoints.finish.setAttribute('aria-hidden',"true");

	_clb=clb;

	await _render();

	for(let i=0;i<3;i++) rpoints[`option_${i}`].setAttribute('tabindex','-1');

	rpoints.result.setAttribute('aria-hidden','true');
	rpoints.choices.setAttribute('aria-hidden','true');
	rpoints.desc.setAttribute('aria-hidden','true');
}

const _select = s => {
	instructions.hide();
	_state.selected=s;
	_state.status='answered';

	_render_steps();
	_render_options();
}

const _check_answer = () => {
	_state.answers[_state.step]=_state.selected;
	_state.finished+=1;

	if(_state.questions[_state.step].opts[_state.selected].valid){
		_state.status='correct';
		audio.play(_state.step===(_amount-1)?'finished':'correct');
	} else {
		audio.play('plunger');
		_state.status = 'incorrect';
	}

	_render_result();
	_render_steps();
	_render_options();
}

const _get_answer = () => {
	if(_state.answers[_state.step]) return _state.answers[_state.step];
	return _state.selected;
}

const _go_to = (i) => {
	_state.step = i;
	if(_state.answers[i]!==undefined){
		_state.status = (_state.questions[i].opts[_state.answers[i]].valid) ? 'correct' : 'incorrect';
		_state.selected = _state.answers[i];
	} else {
		_state.status = 'question';
		_state.selected = undefined;
	}
	_render_options();
	_render_steps();
	_render_result();

	rpoints.q_text.focus();
}

const _next = () => {
	_state.step+=1;
	_state.status = 'question';
	_state.selected = undefined;
	_render_options();
	_render_steps();
	_render_result();


	rpoints.q_text.focus();
}

const _render_options = ()=>{
	let answer = _get_answer();

	let result = false;

	const q=_state.questions[_state.step];

	rpoints.q_text.innerHTML=q.q;
	rpoints.q_img.className=`q${q.i}`;

	if(_state.status==='question' || _state.status==='answered'){
		rpoints.choice_options.classList.remove('disabled');
	} else {
		rpoints.choice_options.classList.add('disabled');
		result = true;
	}

	for(let i=0;i<3;i++){
		rpoints[`option_${i}`].classList[answer===i?'add':'remove']('selected');
		rpoints[`option_${i}`].setAttribute('aria-checked',answer===i);
		rpoints[`option_${i}`].innerHTML=q.opts[i].t;

		if(result){
			rpoints[`option_${i}`].setAttribute('tabindex',-1);
			if(q.opts[i].valid){
				rpoints[`option_${i}`].classList.add('correct');
				rpoints[`option_${i}`].setAttribute('aria-label',`Correct: ${rpoints[`option_${i}`].innerText}`);
			} else {
				rpoints[`option_${i}`].removeAttribute('aria-label');
			}
		} else {
			rpoints[`option_${i}`].removeAttribute('tabindex');
			rpoints[`option_${i}`].removeAttribute('aria-label');
			rpoints[`option_${i}`].classList.remove('correct');
		}
	}
}

const _render = () => Promise.all([
	_render_steps(),
	_render_options(),
	_render_result()
]);

const _render_steps = () => {
	const steps = [];
	for(let i=0;i<_amount;i++){
		if(i<_state.finished){
			steps.push({cls:_state.questions[i].opts[_state.answers[i]].valid?'correct':'incorrect',clb:_state.step!==i?()=>_go_to(i):undefined});
		} else if(i===_state.finished){
			steps.push({cls:'current',clb:_state.step!==i?()=>_go_to(i):undefined});
		} else {
			steps.push({cls:''});
		}
	}

	let btn={};
	switch(_state.status){
		case 'question':
			btn={
				label:'Check Answer',
				cls:'grey',
				hidden:true,
			}
		break;
		case 'answered':
			btn={
				label:'Check Answer',
				cls:'blue',
				clb:_check_answer
			}
		break;
		case 'correct':
		case 'incorrect':
			if(_state.step===(_amount-1)){
				btn={
					label:'Check Answer',
					cls:'hidden',
					hidden:true,
				}
				steps[_amount-1]={cls:_state.status==='incorrect'?'incorrect':'correct'};
				rpoints.finish.classList.remove('hidden');
				rpoints.finish.removeAttribute('tabindex');
				rpoints.finish.removeAttribute('aria-hidden');
				instructions.remove();
			} else {
				btn={
					label:'Next',
					cls:_state.status==='correct'?'green':'red',
					clb:_state.step===_state.finished?_next:()=>_go_to(_state.step+1),
				}
			}
		break;
	}

	steps_component.render({
		btn,
		steps
	});
}


const _render_result = async ()=>{
	rpoints.result.removeAttribute('aria-live');
	if(!rpoints.result.classList.contains('hidden')){
		rpoints.result.classList.add('hidden');
		rpoints.result.setAttribute('aria-hidden','true');
		await wait(250);
	}

	if(!rpoints.desc.classList.contains('hidden')){
		rpoints.desc.classList.add('hidden');
		rpoints.desc.setAttribute('aria-hidden','true');
		await wait(250);
	}

	if(_state.status==='incorrect'){
		rpoints.result.classList.add('incorrect');
		rpoints.result_header.innerHTML='Incorrect';
		//rpoints.result_text.innerHTML=_state.questions[_state.step].r;
		rpoints.result.classList.remove('hidden');
		rpoints.result.removeAttribute('aria-hidden');
		await wait(250);
		rpoints.result.setAttribute('aria-live','polite');
	} else if(_state.status==='correct'){
		rpoints.result.classList.remove('incorrect');
		rpoints.result_header.innerHTML='Correct!';
		//rpoints.result_text.innerHTML=_state.questions[_state.step].r;
		rpoints.result.classList.remove('hidden');
		rpoints.result.removeAttribute('aria-hidden');
		await wait(250);
		rpoints.result.setAttribute('aria-live','polite');
	} else if(_state.status==='question' || _state.status==='answered'){
		rpoints.desc.classList.remove('hidden');
		rpoints.desc.removeAttribute('aria-hidden');
	}

}

const _ext={
	show:({
		parent,
		clb
	})=>{
		parent.insertBefore(el,parent.firstChild);
		_resize();
		init(clb);
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
